function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.2005 24.4331C11.1003 24.4331 3.69632 18.5751 3.69632 11.3743C3.69632 10.7681 3.76733 10.1753 3.86901 9.59094C1.47807 11.4989 0 14.0878 0 16.9455C0 19.8527 1.52352 22.4842 3.98716 24.4006C4.02636 26.5191 3.74517 29.1169 2.30686 31.8237C1.72006 32.9278 2.02283 33.3084 3.1436 32.7347C6.86264 30.8307 9.42399 29.0254 11.2287 27.3639C12.0643 27.4851 12.9238 27.5553 13.8048 27.5553C17.3517 27.5553 20.5754 26.5185 23.0203 24.8289C22.8107 24.6571 22.6005 24.4854 22.4006 24.3119C21.6559 24.3927 20.9185 24.4331 20.2005 24.4331ZM30.7254 19.3666C33.3663 17.3121 35 14.4908 35 11.3743C35 5.09241 28.3737 0 20.2 0C12.0262 0 5.39991 5.09241 5.39991 11.3743C5.39991 17.6562 12.0262 22.7491 20.2 22.7491C21.1452 22.7491 22.066 22.6739 22.9618 22.5437C24.8966 24.3248 27.642 26.2603 31.6297 28.3013C32.0052 28.4933 32.2949 28.5859 32.4966 28.5859C32.9408 28.5859 32.959 28.1391 32.5267 27.3251C30.985 24.4225 30.6834 21.6383 30.7254 19.3666Z",
  fill: "#20A0E1"
});

var SvgChatIcon = function SvgChatIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChatIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-icon.14b824af.svg";
export { ForwardRef as ReactComponent };